var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', {
    attrs: {
      "offset-x": "",
      "max-width": "160",
      "max-height": "90%",
      "nudge-right": _vm.nudgeRight || 4,
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on;
        return [_vm._t("default", null, null, {
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.open,
      callback: function ($$v) {
        _vm.open = $$v;
      },
      expression: "open"
    }
  }, [_c('v-card', {
    staticClass: "pa-2",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._l(_vm.colors, function (color) {
    return [color ? _c('v-btn', {
      directives: [{
        name: "blur",
        rawName: "v-blur"
      }],
      staticClass: "ma-2",
      staticStyle: {
        "background-origin": "border-box"
      },
      style: {
        'background': `
            linear-gradient(${_vm.stripAlpha(color)} 50%, ${color}),
            repeating-conic-gradient(#DDD 0% 25%, transparent 0% 50%) 50% / 20px 20px
          `,
        'outline': _vm.value == color ? '8px solid rgba(0, 0, 0, 0.12) !important' : null,
        'box-shadow': _vm.value == color ? `0 0 #FFF !important` : null,
        'transform': _vm.value == color ? 'scale(.9)' : null
      },
      attrs: {
        "fab": "",
        "x-small": ""
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('input', color);
        }
      }
    }, [!color ? _c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(_vm.mdiCircleOffOutline)
      }
    }) : _vm._e()], 1) : _c('v-btn', {
      staticClass: "ma-1",
      attrs: {
        "icon": "",
        "width": "40",
        "height": "40",
        "input-value": _vm.value == color
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('input', color);
        }
      }
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(_vm.mdiCircleOffOutline)
      }
    })], 1)];
  }), _c('div', {
    staticClass: "ma-n2 pt-4"
  }, [_c('v-divider'), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-x": "",
      "right": "",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var on = _ref2.on;
        return [_c('v-list-item', _vm._g({}, on), [_c('v-list-item-title', [_vm._v("More colors")]), _c('v-list-item-icon', [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiChevronRight)
          }
        })], 1)], 1)];
      }
    }])
  }, [_c('v-card', [_c('div', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-color-picker', {
    attrs: {
      "mode": "rgba",
      "value": _vm.value
    },
    on: {
      "input": function (v) {
        return _vm.$emit('input', v);
      }
    }
  })], 1)])], 1)], 1)], 1)], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }